<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.chargeType' | translate }}</label>
    @if (currentChargeInformationDto != null) {
      <input
        appInput
        [readonly]="true"
        [value]="toTranslationKey('chargeInformation.chargeTypes.', form.get('chargeType')?.value) | translate" />
    }
    @else {
      <select appSelect formControlName="chargeType" [collection]="chargeTypeOptions"></select>
    }
  </app-input-group>

  @if (showObservationPeriodSelector) {
    <app-input-group>
      <label appLabel>{{ 'chargeInformation.observationPeriod' | translate }}</label>
      @if (currentChargeInformationDto != null) {
        <input
          appInput
          [readonly]="true"
          [value]="toTranslationKey('chargeInformation.observationPeriods.', form.get('observationPeriod')?.value) | translate" />
      }
      @else {
        <select appSelect formControlName="observationPeriod" [collection]="observationPeriodOptions"></select>
      }
    </app-input-group>
  }

  @if (showCreateDetails) {
    <app-input-group>
      <label appLabel>{{ 'chargeInformation.chargeTypeId' | translate }}</label>
      <input
        appInput
        formControlName="chargeTypeId"
        [readonly]="currentChargeInformationDto != null"
        placeholder="{{ 'chargeInformation.form.enterChargeTypeId' | translate }}" />
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'chargeInformation.description' | translate }}</label>
      <input
        appInput
        formControlName="description"
        placeholder="{{ 'chargeInformation.form.enterDescription' | translate }}" />
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'chargeInformation.longDescription' | translate }}</label>
      <input
        appInput
        formControlName="longDescription"
        placeholder="{{ 'chargeInformation.form.enterLongDescription' | translate }}" />
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'chargeInformation.validFrom' | translate }}</label>
      <input appInputDate formControlName="validFrom" [defaultDate]="false" [attr.min]="firstValidDateString" />
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'chargeInformation.vatClass' | translate }}</label>
      @if (currentChargeInformationDto != null) {
        <input
          appInput
          [readonly]="true"
          [value]="toTranslationKey('chargeInformation.vatClassOptions.', form.get('vatClass')?.value) | translate" />
      }
      @else {
        <select appSelect formControlName="vatClass" [collection]="vatClassOptions"></select>
      }
    </app-input-group>

    @if (showTransparentInvoicing) {
      <app-input-group>
        <label appLabel>{{ 'chargeInformation.transparentInvoicing' | translate }}</label>
        <input type="checkbox" appInput formControlName="transparentInvoicing">
      </app-input-group>
    }

    @if (isCreateMode) {
      <div class="mt-6 border-t pt-4">
        <h3 class="mb-4 text-base font-medium">{{ 'chargeSetup.title' | translate }}</h3>

        @if (showCreateSinglePrice) {
          <app-input-group>
            <label appLabel>{{ 'chargeSetup.singlePrice' | translate }}</label>
            <input appInputNumber formControlName="singleChargeSetupPrice" [decimals]="6" />
          </app-input-group>
        }

        @if (showCreateDifferentiatedPrices) {
          <app-input-group>
            <label appLabel>{{ 'chargeSetup.loadLevelLow' | translate }}</label>
            <input appInputNumber formControlName="loadLevelLow" [decimals]="6" />
          </app-input-group>

          <app-input-group>
            <label appLabel>{{ 'chargeSetup.loadLevelHigh' | translate }}</label>
            <input appInputNumber formControlName="loadLevelHigh" [decimals]="6" />
          </app-input-group>

          <app-input-group>
            <label appLabel>{{ 'chargeSetup.loadLevelPeak' | translate }}</label>
            <input appInputNumber formControlName="loadLevelPeak" [decimals]="6" />
          </app-input-group>
        }
      </div>
    }
  }
</form>
